import * as React from "react";

import * as Classes from "src/mpd-library";

import { IMPDPanel } from "./panel-props";

export interface IMPDPanelViewProps {
  /**
   * Callback invoked when the user presses the back button or a panel invokes
   * the `closePanel()` injected prop method.
   */
  onClose: (removedPanel: IMPDPanel) => void;

  /**
   * Callback invoked when a panel invokes the `openPanel(panel)` injected
   * prop method.
   */
  onOpen: (addedPanel: IMPDPanel) => void;

  /** The panel to be displayed. */
  panel: IMPDPanel;
}

export class MPDPanelView extends React.PureComponent<IMPDPanelViewProps> {
  public render() {
    const { panel, onOpen } = this.props;
    return (
      <div className={Classes.PANEL_STACK_VIEW}>
        <panel.component
          openPanel={onOpen}
          closePanel={this.handleClose}
          {...panel.props}
        />
      </div>
    );
  }

  private handleClose = () => this.props.onClose(this.props.panel);
}



// WEBPACK FOOTER //
// ./src/mpd-library/panel-stack/panel-view.tsx